/**
 * checkout
 *
 * - toggle Content for mobile / desktop
 * - invoke dataLayer
 */

import * as utility from "@sharedJS/stickyElementUtility";
import breakpoints from "@sharedJS/breakpoints";
import * as resize from "@sharedJS/resize";
import * as utils from "@sharedJS/utils";
import * as dataLayerCheckout from "@shopJS/dataLayerCheckout";
import pushDataLayer from "@ocm/services/dataLayer.js";
import { getFavoriteBrandsToggleDimension } from "@ocm/services/services.favoriteBrandsToggleTracking";

// DOM
let $checkoutContentWrapper;
let $checkoutContentMobileWrapper;
let $checkoutContent;

function _keepFooterOnBottom() {
	if (document.body.classList.contains("page-multiStepCheckoutSummaryPage")) {
		const wrapperStyle = document.querySelector(".js-offcanvas-innerwrapper").style;
		const footer = document.querySelector("footer");
		const footerStyle = footer.style;

		wrapperStyle.position = "relative";
		wrapperStyle.minHeight = "100vh";

		footerStyle.position = "absolute";
		footerStyle.bottom = "0";
		footerStyle.width = "100%";

		let footerHeight = 0;
		const setWrapperPaddingBottom = () => {
			if (footerHeight !== footer.offsetHeight) {
				footerHeight = footer.offsetHeight;
				wrapperStyle.paddingBottom = `${footerHeight}px`;
			}
		};
		setWrapperPaddingBottom();
		window.addEventListener("resize", setWrapperPaddingBottom);
	}
}

function init() {
	_unhideFooterAfterPageLoad();
	$checkoutContentWrapper = $(".js-checkout-content").first();
	$checkoutContentMobileWrapper = $(".js-checkout-mobile-content.is-active").first();
	$checkoutContent = $checkoutContentWrapper.find("> div").first();

	const resizeBreakpoints = resize.addListener(checkout, "breakpoint");
	_initScreen(resizeBreakpoints);

	if (utils.getPageUid() === "multiStepCheckoutSummaryPage") {
		const checkoutStep = getCheckoutStep();
		dataLayerCheckout.pushPageLoad(checkoutStep);

		if (checkoutStep === 5) {
			_initFixedSummary();
			_trackPaymentMethod();
		}
	} else if (utils.getPageType() === "ThankYouPage") {
		dataLayerCheckout.pushPageLoadThankYouPage();
	}
}

function _unhideFooterAfterPageLoad() {
	window.onload = function () {
		$("#js-vue-checkout-footer").css("display", "block");
		_keepFooterOnBottom();
	};
	// to make sure onload works in every browser: https://stackoverflow.com/a/1033557
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	window.onunload = function () {};
}

const _trackPaymentMethod = function () {
	const $paymentMethod = $(".js-checkout--payment").attr("data-code");
	const dataLayerCheckoutOption = {
		event: "checkoutOption",
		ecommerce: {
			...getFavoriteBrandsToggleDimension(),
			checkout_option: {
				actionField: { step: 4, option: $paymentMethod },
			},
		},
	};

	pushDataLayer(dataLayerCheckoutOption);
};

const getCheckoutStep = function () {
	const url = window.location.href;
	if (url.indexOf("payment-address") > -1) {
		return 2;
	}
	if (url.indexOf("delivery-address") > -1) {
		return 3;
	}
	if (url.indexOf("payment-method") > -1) {
		return 4;
	}
	if (url.indexOf("multi/summary") > -1) {
		return 5;
	}
	return 0;
};

// necessary Method for resize.js
function updateResize(breakpoints) {
	const myBreakpoint = "l_down";

	if (breakpoints[myBreakpoint] && breakpoints[myBreakpoint].hasChanged) {
		if (breakpoints[myBreakpoint].isScreenSize) {
			$checkoutContentMobileWrapper.prepend($checkoutContent);
		} else {
			$checkoutContentWrapper.prepend($checkoutContent);
		}
	}
}

function _initScreen(screenSizes) {
	const myBreakpoint = "l_down";

	if (screenSizes[myBreakpoint]) {
		if (screenSizes[myBreakpoint].isScreenSize) {
			$checkoutContentMobileWrapper.prepend($checkoutContent);
		} else {
			$checkoutContentWrapper.prepend($checkoutContent);
		}
	}
}

function _initFixedSummary() {
	const $window = $(window);
	let $stickyElement;
	let $spacingElement;

	if (Modernizr.mq(breakpoints["m"])) {
		$stickyElement = $(".js-checkout-price-summary");
		$spacingElement = $(".js-summary-spacing");
	} else if (Modernizr.mq(breakpoints["m_down"])) {
		$stickyElement = $(".js-checkout-price-summary-btn");
		$spacingElement = $(".js-summary-spacing-m-down");
	}

	if ($stickyElement && $spacingElement) {
		utility.fixedStickyElement($stickyElement, $spacingElement);
		$window.scroll(() => {
			utility.fixedStickyElement($stickyElement, $spacingElement);
		});
	}
}

const checkout = {
	init,
	updateResize,
};

export default checkout;
